import React from "react";
import styles from "./modalContainerWrapper.module.scss";
import { ReactChildrenProps } from "../../types/ReactChildrenProps";

export interface ModalContainerWrapperProps extends ReactChildrenProps {
    title?: string;
}

export const ModalContainerWrapper: React.FC<ModalContainerWrapperProps> = (props: ModalContainerWrapperProps) => (
    <div className={styles.wrapper}>
        {props.title && <h3 className={styles.title}>{props.title}</h3>}
        {props.children}
    </div>
);
